import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { ReplaySubject, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserIssueConnectionAudit } from '../../../classes';
import { IIssueAuditWrapperProvider, ISSUE_AUDIT_WRAPPER_PROVIDER } from '../../../interfaces';

@Component({
  selector: 'app-issue-user-assignment-audit',
  templateUrl: './issue-user-assignment-audit.component.html',
  styleUrls: ['./issue-user-assignment-audit.component.css']
})
export class IssueUserAssignmentAuditComponent implements OnDestroy, OnInit {

  private _audit = new ReplaySubject<UserIssueConnectionAudit[]>();
  @Input() set userIssueConnectionAudit(audit: UserIssueConnectionAudit[]) {
    this._audit.next(audit);
  }

  assignedUsers$ = this._audit.pipe(map(x => x.filter(y => y.isAssigned)));

  private _subscriptions: Subscription[] = [];

  constructor(
    @Inject(ISSUE_AUDIT_WRAPPER_PROVIDER) private _issueAuditWrapperProvider: IIssueAuditWrapperProvider
  ) { }

  ngOnDestroy(): void {
    for(let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this._subscriptions.push(...[
      this._issueAuditWrapperProvider.issueAuditWrapper$.subscribe((wrapper) => this.userIssueConnectionAudit = wrapper.issueUserAssignments)
    ]);
  }

}
